import createPusherEventHandlersForService from 'shared/clients/pusher/createPusherEventHandlersForService.js';
import { DESTINATIONS_SERVICE_KEY } from 'web/destinations/destinationsEnum';

export default createPusherEventHandlersForService(DESTINATIONS_SERVICE_KEY);
